import { HttpInterceptorFn } from '@angular/common/http';

export const authHashInterceptor: HttpInterceptorFn = (req, next) => {
  const authTelegramData = localStorage.getItem('authTelegramData');
  if (authTelegramData) {
    req = req.clone({
      setHeaders: { 'X-Telegram-Init-Data': authTelegramData }
    });
  }

  return next(req);
};
